import { render, staticRenderFns } from "./HomepageHero.vue?vue&type=template&id=3fd315dc"
import script from "./HomepageHero.vue?vue&type=script&lang=js"
export * from "./HomepageHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports